<template>
    <div class="text-sm">
        {{ modelValue }}
    </div>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: String,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<FieldComponent>(), {});
</script>
